import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useOrderService } from "contexts/ServiceContext";
import { contractQueryKeyFactory } from "hooks/api/contracts/useContractDetails";
import useRefetchOrders from "hooks/useRefetchOrders";
import useSelectedContractDocEntry from "hooks/useSelectedContractDocEntry";
import { CreateContractRequestOrderValues } from "services/OrderService";
import { BrokenRuleValidationError } from "services/apiErrors";
import { CONTRACTS_QUERY_KEY } from "../contracts/useContracts";

const useCreateContractOrderRequest = (
  customerCode: string,
  contractNumber?: number
) => {
  const orderService = useOrderService();
  const refetchOrders = useRefetchOrders();
  const queryClient = useQueryClient();
  const selectedContractDocEntry = useSelectedContractDocEntry();
  return useMutation<
    Record<string, any>,
    BrokenRuleValidationError | Error,
    CreateContractRequestOrderValues
  >({
    mutationKey: [
      "create-contract-order-request",
      { contractNumber, customerCode },
    ],
    mutationFn: (requestOrderValues: CreateContractRequestOrderValues) => {
      return contractNumber && customerCode
        ? orderService.createRequestOrder(contractNumber, {
            values: requestOrderValues,
            customerNumber: customerCode,
          })
        : Promise.reject("Invalid or missing contract number or card code");
    },
    onSuccess: () =>
      Promise.all([
        refetchOrders(contractNumber),
        queryClient.refetchQueries(
          contractQueryKeyFactory(selectedContractDocEntry)
        ),
        queryClient.refetchQueries([CONTRACTS_QUERY_KEY]),
      ]),
  });
};

export default useCreateContractOrderRequest;
